import { render } from "./TrainingVideos.vue?vue&type=template&id=ab44714c"
import script from "./TrainingVideos.vue?vue&type=script&lang=js"
export * from "./TrainingVideos.vue?vue&type=script&lang=js"

import "./TrainingVideos.vue?vue&type=style&index=0&id=ab44714c&lang=scss"

import exportComponent from "C:\\Users\\caleb\\OneDrive\\Desktop\\apps\\kff_ordering_portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__